<script lang="ts">
export default {
  name: "LeftMonitor",
};
</script>
<script setup lang="ts">
import { store } from "@/store"
import { getDeviceTopo1, createFlightTasks, getUnreadDeviceHms } from "@/api/monitorApi/index"
import { getPrepareJobsAPageList, getWayLineList, getWayLineInfo } from "@/api/eventApi/index"
import { Task, FormQuery } from "@/api/monitorApi/types"
import { TaskStatusColor, TaskStatusMap } from '@/types/task'
import { DeviceTypeName, EBizCode, DroneInDockEnum, RainfallEnum } from '@/types/enum'
import { EModeCode, EDockModeCode, EGear } from '@/types/device'
import { onMounted } from "vue";
import { useRoute } from 'vue-router';
import router from "@/router"
import * as echarts from 'echarts'
import BaseEcharts from '@/components/BaseEcharts/index.vue'
import camera from "@/assets/images/xiangji.png"
import { useVueCesium } from 'vue-cesium'
import type { VcViewerProvider, VcReadyObject } from 'vue-cesium/es/utils/types'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'
import homeAlert from "@/views/homePage/components/home-alert.vue";

const $vc: VcViewerProvider = useVueCesium()

const route = useRoute();
const str = '--'
const airNumberValue = ref(store.informationListStore.informationStore().airNumberValue)
const airOptions: any = ref([])
const airInfo = ref()
const popActive = ref(false)
const pageTop = ref(0)

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

const uavList: any = ref([])
async function getOnlineTopo() {
  const params: any = {}
  params.page = 1
  params.size = 999
  params.domain = [2,3]
  // params.domain = 3
  params.orgId = organizationData.value.provinceCode,
    await getDeviceTopo1(params).then((res) => {
      airOptions.value = res.list
    })
}


const searchJobValue: any = ref({

});
const page = ref({
  page: 1,
  size: 999
});

const manualActive = ref(true)

const wayLineList: any = ref()
async function PrepareJobsAPageList() {
  searchJobValue.value.deviceSn = airNumberValue.value
  searchJobValue.value.orgId = organizationData.value.provinceCode
  const params = { ...page.value, ...searchJobValue.value } as any;
  const result = await getWayLineList(params);
  wayLineList.value = result.list;
}
const wayLineActive = ref(false)
const waylineId = ref()
const wayLineClick = (list: any) => {
  if (list.wayline_id != waylineId.value) {
    wayLineActive.value = true
  } else {
    wayLineActive.value = false
  }
  if (wayLineActive.value) {
    waylineId.value = list.wayline_id
    store.informationListStore.informationStore().setWayLineId(list.wayline_id)
  } else {
    waylineId.value = ""
    store.informationListStore.informationStore().setWayLineId("")
  }
}

const submitBtn = (event?: any) => {
  store.informationListStore.informationStore().updateInputValue(airNumberValue.value);
  const airObj = airOptions.value.find((obj: any) => obj.deviceSn === airNumberValue.value);
  console.log(airObj)
  store.informationListStore.informationStore().setUavObj(airObj);
  if (airObj.deviceSn == '') {
    searchJobValue.value.deviceSn = ''
    osdVisible.value.sn = ""
    osdVisible.value.gateway_sn = ""
    osdVisible.value.visible = false
  } else {
    searchJobValue.value.deviceSn = airObj.deviceSn
    osdVisible.value.sn = airObj.childSn
    osdVisible.value.visible = true
    osdVisible.value.gateway_sn = airObj.deviceSn
    osdVisible.value.gateway_callsign = airObj.nickName
    osdVisible.value.dockControlPanelVisible = false
  }
  flyToCamera(
    $vc.viewer,
    {
      position: Cesium.Cartesian3.fromDegrees(airObj.longitude - 0.0005, airObj.latitude - 0.083, 5000),
      heading: 6.283185307179586,
      pitch: -0.5001412827126326,
      roll: 6.283185307179586
    },
  )
  PrepareJobsAPageList()
}

function formatTaskStatus(task: Task) {
  const statusObj = {
    text: '',
    color: ''
  }
  const { status } = task
  statusObj.text = TaskStatusMap[status]
  statusObj.color = TaskStatusColor[status]
  return statusObj
}

const airportObj = ref()
const uavObj: any = reactive({
  gateway: {
    capacity_percent: str,
    transmission_signal_quality: str,
  },
  dock: {

  },
  device: {
    gear: -1,
    mode_code: EModeCode.Disconnected,
    height: str,
    home_distance: str,
    horizontal_speed: str,
    vertical_speed: str,
    wind_speed: str,
    wind_direction: str,
    elevation: str,
    position_state: {
      gps_number: str,
      is_fixed: 0,
      rtk_number: str
    },
    battery: {
      capacity_percent: str,
      landing_power: str,
      remain_flight_time: 0,
      return_home_power: str,
    },
    latitude: 0,
    longitude: 0,
  }
})

const JXsls = (val: any) => {
  switch (val) {
    case '0-67-0':
      return 'Matrice 30'
    case '0-67-1':
      return 'Matrice 30T'
    case '0-77-0':
      return 'MAVIC 3E'
    case '0-91-1':
      return 'M3TD'
    case '0-77-1':
      return 'Mavic 3'
    case '0-60-0':
      return 'Matrice 300 RTK'
    case '0-89-0':
      return 'Matrice 350 RTK'
    default:
      return val
  }
}
const mouseenter = (event: any, list: any) => {
  popActive.value = true
  pageTop.value = event.y - 200
  airportObj.value = mqttList.value.dockInfo[list.dockSn]
  if (airportObj.value && airportObj.value.sub_device) {
    const device_sn = airportObj.value.sub_device.device_sn
    if (mqttList.value.deviceInfo && mqttList.value.deviceInfo[device_sn]) {
      uavObj.device = mqttList.value.deviceInfo[device_sn]
    }
  }
}

const mouseleave = () => {
  popActive.value = false
  pageTop.value = 0
}

const workspaceId = localStorage.getItem("Workspace_id") || "";

const formQuery = reactive<FormQuery>({
  taskType: 0,
  rthAltitude: 120, // 相对机场返航高度 20 - 500
  outOfControlAction: 0,
  frequency: "day",
  manualLen: undefined,
  prepareJobResp: {
    isFlight: 0
  },
});

const jobVisible = ref(false)
const wayLineObj = ref()

//执行
const executeBtn = (list: any) => {
  console.log(list)
  if (deviceInfo.dock?.basicOsd?.wind_speed > 6) {
    ElMessage.warning("当前风速较高，请勿执行任务");
    return
  }

  if (deviceInfo.dock?.basicOsd?.rainfall == 2 || deviceInfo.dock?.basicOsd?.rainfall > 2) {
    ElMessage.warning("当前雨量较大，请勿执行任务");
    return
  }
  jobVisible.value = true
  wayLineObj.value = list
}

const onFinish = () => {
  // if (formQuery.rthAltitude - deviceInfo.dock?.basicOsd?.height < 20) {
  //   ElMessage.warning("高度较低，无法执行任务");
  //   return
  // }
  const params = { ...formQuery };
  params.name = wayLineObj.value.name;
  params.fileId = wayLineObj.value.wayline_id;
  params.dockSn = wayLineObj.value.device_sn;
  params.fileName = wayLineObj.value.name;
  params.orgId = wayLineObj.value.org_id
  params.dockName = airOptions.value?.find(item => item.deviceSn == params.dockSn)?.nickName
  if (formQuery.taskType === 0) {
    delete params.executeTime;
    delete params.frequency;
  }
  createFlightTasks(params).then((res) => {
    ElMessage.success("执行成功！");
    store.informationListStore.informationStore().setExecutionStatus(true)
    sessionStorage.setItem("wayline_id", wayLineObj.value.wayline_id)
    sessionStorage.setItem("autoDetect", formQuery.autoDetect)
    sessionStorage.setItem("jobId", res.jobId)
    closeDialog()
  });
}

const closeDialog = () => {
  jobVisible.value = false
}

const theEDockModeCode = reactive(['已断开', '空闲中', '调试中', '远程调试', '升级中', '运行中', "待标定"])
const theEModeCode = reactive(['待机', '准备中', '已准备', '手动', '自动', '航点', '全景', '运行轨迹', 'ADS_B', '返航', '着陆', '强制着陆', '三叶着陆', '升级中', '未开机', "APAS", "虚拟摇杆状态", "指令飞行", "空中 RTK 收敛模式", "机场选址中", "POI环绕"])
const osdVisible = computed(() => store.other.useMyStore().getOsdVisible)
// 机场状态
const dockInfo = computed(() => store.other.useMyStore().getDockInfo)
// 无人机状态
const deviceInfo1 = computed(() => store.other.useMyStore().getDeviceStatus)
const deviceInfo: any = reactive({
  gateway: {
    capacity_percent: str,
    transmission_signal_quality: str,
  },
  dock: {

  },
  device: {
    gear: -1,
    mode_code: EModeCode.Disconnected,
    height: str,
    home_distance: str,
    horizontal_speed: str,
    vertical_speed: str,
    wind_speed: str,
    wind_direction: str,
    elevation: str,
    position_state: {
      gps_number: str,
      is_fixed: 0,
      rtk_number: str
    },
    battery: {
      capacity_percent: str,
      landing_power: str,
      remain_flight_time: 0,
      return_home_power: str,
    },
    latitude: 0,
    longitude: 0,
  }
})
const mqttList = ref()


watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
  // console.log(data)
  mqttList.value = data
  // console.log(osdVisible.value.gateway_sn)
  if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
    if (osdVisible.value.visible && osdVisible.value.sn !== '') {
      deviceInfo.device = data.deviceInfo[osdVisible.value.sn]
    }
    // console.log('设备状态:', data.deviceInfo)
  }
  if (data.currentType === DeviceTypeName.Dock && data.dockInfo[data.currentSn]) {
    if (osdVisible.value.visible && osdVisible.value.gateway_sn !== '') {
      deviceInfo.dock = data.dockInfo[osdVisible.value.gateway_sn]
    }
    // console.log(deviceInfo.dock)
    // console.log('机场状态:', data.dockInfo[osdVisible.value.gateway_sn])
    // airportIcon.value = data.dockInfo[data.currentSn].basicOsd
    // console.log(airportIcon.value)
  }
}, {
  immediate: true,
  deep: true
})

const flyDataArr = computed(() => Math.abs(deviceInfo.device.attitude_head));
const pieNum = computed(() => Number((flyDataArr.value * 100) / 360));
let max = 360
let colorSet = {
  color: 'rgba(59,191,253,1)',
}
const flyChartOptions = computed(() => ({
  series: [
    {
      name: '内部进度条',
      type: 'gauge',
      radius: '100%',
      startAngle: 90, // 仪表盘起始角度
      endAngle: 450, // 仪表盘结束角度（0度代表正上方）
      min: 0,
      max: 360,
      // detail: {show: false},
      splitNumber: 4,
      splitLine: {
        show: true,
        distance: 0,
        length: 4,
        lineStyle: {
          color: '#ddd', //用颜色渐变函数不起作用
          width: 1,
        },
      },
      axisLine: {
        lineStyle: {
          color: [
            [flyDataArr.value / 360, colorSet.color],
            [1, colorSet.color],
          ],
          width: 2,
        },
      }, //仪表盘轴线
      axisLabel: {
        show: true,
        color: '#ffffff',
        fontSize: 14,
        fontWeight: 'bold',
        distance: -45,
      }, //刻度标签。
      //          axisLabel: {
      //     show: true,
      //     distance: 20,
      //     formatter: function (value) {
      //         return value;
      //     },
      //     textStyle: {
      //         color: '#fff',
      //         fontSize: 15
      //     }
      // },
      axisTick: {
        show: false,
      },
      itemStyle: {
        color: '#ffffff',
      },
      detail: {
        show: false,
        formatter: (value: any) => {
          if (value !== 0) {
            var num: any = Math.round(value)
            return parseInt(num).toFixed(0) + '°'
          } else {
            return 0
          }
        },
        offsetCenter: ['0', '90%'],
        fontSize: 8,
        fontWeight: '700',
        color: '#ffffff',
      },
      title: {
        show: false,
        offsetCenter: [0, '100%'],

        color: '#fff',
        fontSize: 8, //表盘上的标题文字大小
        fontWeight: 400,
      },
      data: [
        {
          value: flyDataArr.value,
          name: "",
        },
      ],
      pointer: {
        show: true,
        length: '50%',
        width: "50%",
        icon: 'path://M700.065799 373.027761q116.507301 104.243374 209.508743 189.068865 39.857761 35.769785 77.671534 71.028574t67.451595 63.36362 47.522715 47.011718 17.884893 21.972868l0 61.319632q0 4.087975-17.884893-1.532991t-47.522715-17.373896-67.451595-27.593834-77.671534-33.214801q-93.001442-40.879755-209.508743-95.04543l0 193.156841q26.571841 19.417883 50.077699 37.813773 20.439877 15.329908 40.879755 30.148819t31.68181 22.994862q13.28592 9.197945 15.329908 18.906887t2.043988 22.994862l0 34.747791q0 8.175951-16.862899 10.730936t-40.368758-8.686948q-11.241933-6.131963-40.879755-18.39589t-63.36362-26.571841-64.896611-26.571841-46.500721-18.39589q-2.043988 0-3.576979-0.510997t-3.576979-0.510997-3.576979 0.510997-3.576979 0.510997q-15.329908 6.131963-46.500721 18.39589t-64.896611 26.571841-63.36362 26.571841-40.879755 18.39589q-23.505859 11.241933-40.368758 8.686948t-16.862899-10.730936l0-34.747791q0-13.28592 2.043988-22.994862t15.329908-18.906887q11.241933-8.175951 31.68181-22.994862t40.879755-30.148819q23.505859-18.39589 50.077699-37.813773l0-193.156841q-117.529295 54.165675-210.530737 95.04543-39.857761 17.373896-77.160537 33.214801t-66.940598 27.593834-47.522715 17.373896-17.884893 1.532991l0-61.319632q0-3.065982 17.884893-21.972868t47.522715-47.011718 66.940598-63.36362 77.160537-71.028574q93.001442-84.825491 210.530737-189.068865l0-231.992608q0-34.747791 10.219939-58.764647t25.549847-39.346764 33.214801-23.505859 33.725798-12.263926 26.060844-4.598972 11.241933-0.510997l10.219939 0q11.241933 1.021994 27.082837 5.109969t33.725798 12.263926 33.214801 23.505859 25.549847 39.346764 10.219939 58.764647l0 231.992608z',
        offsetCenter: [0, "25%"] // 修改偏移中心点为[0, 0]
      },
      animationDuration: 1000,
      z: 8,
    },
    {
      type: 'pie',
      name: '内层细圆环',
      radius: ['20%', '58%'],
      emphasis: {
        scale: false,
      },
      z: 2,

      startAngle: 90,
      itemStyle: {
        color: [
          [
            flyDataArr.value / 360,
            new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: 'rgba(59,191,253,0.1)',
              },
              {
                offset: 0.5,
                color: 'rgba(59,191,253,0.4)',
              },
              {
                offset: 1,
                color: 'rgba(59,191,253,0.6)',
              },
            ]),
          ],
        ],
      },
      label: {
        show: false,
      },
      data: [
        {
          value: pieNum.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              {
                offset: 0,
                color: 'rgba(59,191,253,0.1)',
              },
              {
                offset: 0.5,
                color: 'rgba(59,191,253,0.4)',
              },
              {
                offset: 1,
                color: 'rgba(59,191,253,0.6)',
              },
            ]),
          },
        },
        {
          value: 100 - pieNum.value,
          itemStyle: {
            color: 'rgba(255,255,255,0)',
          },
        },
      ],
      animation: true,
    },
    {
      type: 'pie',
      name: '内层细圆环',
      radius: ['62%', '70%'],
      emphasis: {
        scale: false,
      },
      z: 2,
      startAngle: 90,
      itemStyle: {
        color: 'rgba(59,191,253,1)',
      },
      label: {
        show: false,
      },
      data: [
        {
          value: pieNum.value,
          itemStyle: {
            color: 'rgba(59,191,253,1)',
          },
        },
        {
          value: 100 - pieNum.value,
          itemStyle: {
            color: 'rgba(255,255,255,0)',
          },
        },
      ],
      animation: true,
    },
    {
      name: '内部小环',
      type: 'gauge',
      radius: '40%',
      axisLine: {
        lineStyle: {
          color: [[1, colorSet.color]],
          width: 1,
        },
      },
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      itemStyle: {
        color: '#ffffff',
      },
      detail: {
        show: false,
      },
      title: {
        show: false,
      },
      pointer: {
        show: false,
      },
    },
  ],
}))

const ptzDataArr = computed(() => Math.abs(deviceInfo.device?.payload?.gimbal_pitch.toFixed(1)));
const piePtzNum = computed(() => Number((ptzDataArr.value * 100) / 360));
const ptzChartOptions = computed(() => ({
  series: [
    {
      name: '内部进度条',
      type: 'gauge',
      radius: '100%',
      startAngle: 90, // 仪表盘起始角度
      endAngle: 450, // 仪表盘结束角度（0度代表正上方）
      min: 0,
      max: 360,
      // detail: {show: false},
      splitNumber: 4,
      splitLine: {
        show: true,
        distance: 0,
        length: 4,
        lineStyle: {
          color: '#ddd', //用颜色渐变函数不起作用
          width: 1,
        },
      },
      axisLine: {
        lineStyle: {
          color: [
            [ptzDataArr.value / 360, colorSet.color],
            [1, colorSet.color],
          ],
          width: 2,
        },
      }, //仪表盘轴线
      axisLabel: {
        show: true,
        color: '#ffffff',
        fontSize: 14,
        fontWeight: 'bold',
        distance: -45,
      }, //刻度标签。
      //          axisLabel: {
      //     show: true,
      //     distance: 20,
      //     formatter: function (value) {
      //         return value;
      //     },
      //     textStyle: {
      //         color: '#fff',
      //         fontSize: 15
      //     }
      // },
      axisTick: {
        show: false,
      },
      itemStyle: {
        color: '#ffffff',
      },
      detail: {
        show: false,
        formatter: (value: any) => {
          if (value !== 0) {
            var num: any = Math.round(value)
            return parseInt(num).toFixed(0) + '°'
          } else {
            return 0
          }
        },
        offsetCenter: ['0', '90%'],
        fontSize: 16,
        fontWeight: '700',
        color: '#ffffff',
      },
      title: {
        show: true,
        offsetCenter: [0, '100%'],

        color: '#fff',
        fontSize: 12, //表盘上的标题文字大小
        fontWeight: 400,
      },
      data: [
        {
          value: ptzDataArr.value,
          name: "",
        },
      ],
      pointer: {
        show: true,
        length: '50%',
        width: "25%",
        icon: camera,
        offsetCenter: [0, "25%"] // 修改偏移中心点为[0, 0]
      },
      animationDuration: 1000,
      z: 8,
    },
    {
      type: 'pie',
      name: '内层细圆环',
      radius: ['20%', '58%'],
      emphasis: {
        scale: false,
      },
      z: 2,

      startAngle: 90,
      itemStyle: {
        color: [
          [
            ptzDataArr.value / 360,
            new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: 'rgba(59,191,253,0.1)',
              },
              {
                offset: 0.5,
                color: 'rgba(59,191,253,0.4)',
              },
              {
                offset: 1,
                color: 'rgba(59,191,253,0.6)',
              },
            ]),
          ],
        ],
      },
      label: {
        show: false,
      },
      data: [
        {
          value: piePtzNum.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              {
                offset: 0,
                color: 'rgba(59,191,253,0.1)',
              },
              {
                offset: 0.5,
                color: 'rgba(59,191,253,0.4)',
              },
              {
                offset: 1,
                color: 'rgba(59,191,253,0.6)',
              },
            ]),
          },
        },
        {
          value: 100 - piePtzNum.value,
          itemStyle: {
            color: 'rgba(255,255,255,0)',
          },
        },
      ],
      animation: true,
    },
    {
      type: 'pie',
      name: '内层细圆环',
      radius: ['62%', '70%'],
      emphasis: {
        scale: false,
      },
      z: 2,
      startAngle: 90,
      itemStyle: {
        color: 'rgba(59,191,253,1)',
      },
      label: {
        show: false,
      },
      data: [
        {
          value: piePtzNum.value,
          itemStyle: {
            color: 'rgba(59,191,253,1)',
          },
        },
        {
          value: 100 - piePtzNum.value,
          itemStyle: {
            color: 'rgba(255,255,255,0)',
          },
        },
      ],
      animation: true,
    },
    {
      name: '内部小环',
      type: 'gauge',
      radius: '40%',
      axisLine: {
        lineStyle: {
          color: [[1, colorSet.color]],
          width: 1,
        },
      },
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      itemStyle: {
        color: '#ffffff',
      },
      detail: {
        show: false,
      },
      title: {
        show: false,
      },
      pointer: {
        show: false,
      },
    },
  ],
}))

const speedChartOptions1 = computed(() => ({
  series: [
    {
      name: '内层数据刻度',
      type: 'gauge',
      radius: '100',
      min: 0,
      max: 100,
      center: ['50%', '60%'],
      startAngle: 180,
      endAngle: -6,
      splitNumber: 5,

      axisLine: {
        show: false,
        roundCap: true,
        lineStyle: {
          width: 12,
          // color: [[0.2, '#77D97F'],[0.8, '#4285F4'],[1, '#FF7E7F']],
          color: [[1, '#3383a2']],
        },
      },

      pointer: {
        length: '30%',
        width: 2,
        offsetCenter: [0, 0],
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#ffffff',
              },
              {
                offset: 0.7,
                color: '#ffffff',
              },
              {
                offset: 1,
                color: '#2d7a8b',
              },
            ],
            // global: false // 缺省为 false
          },
          // shadowColor: 'rgba(0, 0, 0, 0.5)',
          shadowBlur: 7,
          shadowColor: '#ffffff',
        },
      },
      detail: {
        show: false,
        offsetCenter: ['6%', '0%'],
        formatter: function (value) {
          return '{value|' + value.toFixed(0) + '}{unit|m/s}';
        },
        rich: {
          value: {
            fontSize: 14,
            fontWeight: 'bolder',
            fontFamily: "YouSheBiaoTiHei",
            color: '#ffffff',
            textShadowBlur: '12',
            textShadowColor: '#3ea0b5',
          },
          unit: {
            fontSize: 6,
            fontWeight: 'bolder',
            color: '#ffffff',
            textShadowBlur: '12',
            textShadowColor: '#3ea0b5',
          },
        },
      },
      data: [
        {
          value: deviceInfo.device?.horizontal_speed,
        },
      ],
    },

  ],
}))

const speedChartOptions2 = computed(() => ({
  series: [
    {
      name: '内层数据刻度',
      type: 'gauge',
      radius: '100',
      min: 0,
      max: 100,
      center: ['50%', '60%'],
      startAngle: 180,
      endAngle: -6,
      splitNumber: 5,

      axisLine: {
        show: false,
        roundCap: true,
        lineStyle: {
          width: 12,
          // color: [[0.2, '#77D97F'],[0.8, '#4285F4'],[1, '#FF7E7F']],
          color: [[1, '#3383a2']],
        },
      },

      pointer: {
        length: '30%',
        width: 2,
        offsetCenter: [0, 0],
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#ffffff',
              },
              {
                offset: 0.7,
                color: '#ffffff',
              },
              {
                offset: 1,
                color: '#2d7a8b',
              },
            ],
            // global: false // 缺省为 false
          },
          // shadowColor: 'rgba(0, 0, 0, 0.5)',
          shadowBlur: 7,
          shadowColor: '#ffffff',
        },
      },
      detail: {
        show: false,
        offsetCenter: ['6%', '0%'],
        formatter: function (value) {
          return '{value|' + value.toFixed(0) + '}{unit|m/s}';
        },
        rich: {
          value: {
            fontSize: 14,
            fontWeight: 'bolder',
            fontFamily: "YouSheBiaoTiHei",
            color: '#ffffff',
            textShadowBlur: '12',
            textShadowColor: '#3ea0b5',
          },
          unit: {
            fontSize: 6,
            fontWeight: 'bolder',
            color: '#ffffff',
            textShadowBlur: '12',
            textShadowColor: '#3ea0b5',
          },
        },
      },
      data: [
        {
          value: deviceInfo.device?.vertical_speed,
        },
      ],
    },

  ],
}))
const homeEventVisible = ref(false)
const treatBtn = () => {
  if (deviceInfo.dock?.basicOsd?.wind_speed > 6) {
    ElMessage.warning("当前风速较高，请勿执行任务");
    return
  }

  if (deviceInfo.dock?.basicOsd?.rainfall == 2 || deviceInfo.dock?.basicOsd?.rainfall > 2) {
    ElMessage.warning("当前雨量较大，请勿执行任务");
    return
  }
  homeEventVisible.value = true
  store.informationListStore.informationStore().setTreatActive(false)
}

const leftActive = ref(true)

watch(() => store.informationListStore.informationStore().contractActive, (data, oldVal) => {
  console.log(data)
  leftActive.value = data
}, {
  deep: true
})

const infoActive = ref(true)

const switchBtn = (num: number) => {
  if (num) {
    infoActive.value = false
  } else {
    infoActive.value = true
  }
}

const backBtn = () => {
  router.push({
    path: "/flightList"
  })
  flyToCamera(
    $vc.viewer,
    {
      //小浦
      // position: Cesium.Cartesian3.fromDegrees(119.840, 31.010, 1000),
      //吕山
      // position: Cesium.Cartesian3.fromDegrees(119.932, 30.910, 1000),
      //丽水
      //千岛湖
      position: Cesium.Cartesian3.fromDegrees(Number(localStorage.getItem("lng")) - 0.0005, Number(localStorage.getItem("lat")) - 0.0115, Number(localStorage.getItem("alt"))),
      heading: 6.283185307179586,
      pitch: -0.5001412827126326,
      roll: 6.283185307179586
    },
  )
}

function storageFormatter(data: any) {
  const gb = Number(data / 1024 / 1024).toFixed(1)
  const mb = Number(data / 1024).toFixed(1)
  const kb = Number(data)
  return gb >= 1 ? (gb + 'G') : mb >= 1 ? (mb + 'M') : kb ? (kb + 'K') : '0'
}

function getOnlineDeviceHms() {
  const airObj = airOptions.value.find((obj: any) => obj.deviceSn === airNumberValue.value);
  getUnreadHms(airObj.deviceSn)
  getUnreadHms(airObj.childSn)
}

const hmsInfo = computed({
  get: () => store.other.useMyStore().hmsInfo,
  set: (val) => {
    return val
  }
})
function getUnreadHms(sn: any) {
  getUnreadDeviceHms({
    startTime: Date.now() - (5 * 60 * 1000),
    deviceSn: sn,
  }).then(res => {
    if (res.deviceHmsRespList.length !== 0) {
      hmsInfo.value[sn] = res.deviceHmsRespList
    }
  })
}
function Msgformatter(data: any) {
  const messageZn: any = []
  data?.forEach((item: any) => {
    messageZn.push(item.messageZh)
  })
  return messageZn.join(';')
}

const ifmActive = ref(false)
const status = ref("1")
watch(() => store.informationListStore.informationStore().airValueActive, (data, oldVal) => {
  console.log(data)
  if(!store.informationListStore.informationStore().treatActive){
    return
  }
  if (data == 1) {
    ifmActive.value = false
  } else {
    ifmActive.value = true
  }
}, {
  deep: true
})

watch(() => store.informationListStore.informationStore().treatActive,
   (newVal: boolean) => {
      console.log(newVal)
      if (newVal) {
        ifmActive.value = true
      } else {
         ifmActive.value = false
      }
   }, {
    immediate:true,
   deep: true
}
);

function GetQueryString(name: any) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  let context = '';
  if (r) context = r[2];
  return context ? context : '';
}

onMounted(async () => {
  await getOnlineTopo()
  if (route.query.deviceSn) {
    airNumberValue.value = route.query.deviceSn
    store.informationListStore.informationStore().updateInputValue(airNumberValue.value);
    const airObj = airOptions.value.find((obj: any) => obj.deviceSn === airNumberValue.value);
    console.log(airOptions.value)
    console.log(airObj)
    airInfo.value = airObj
    store.informationListStore.informationStore().setUavObj(airObj);
    if (airObj.deviceSn == '') {
      searchJobValue.value.deviceSn = ''
      osdVisible.value.sn = ""
      osdVisible.value.gateway_sn = ""
      osdVisible.value.visible = false
    } else {
      searchJobValue.value.deviceSn = airObj.deviceSn
      osdVisible.value.sn = airObj.childSn
      osdVisible.value.visible = true
      osdVisible.value.gateway_sn = airObj.deviceSn
      osdVisible.value.gateway_callsign = airObj.nickName
      osdVisible.value.dockControlPanelVisible = false
    }
    // submitBtn()
    setTimeout(() => {
      getOnlineDeviceHms()
    }, 3000)
  }
  if (GetQueryString("status")) {
    status.value = GetQueryString("status")
  }
  PrepareJobsAPageList()
  if(route.query.domain == 2){
    manualActive.value = false
    infoActive.value = false
  }
})

</script>

<template>
  <div class="left-monitor" v-if="leftActive">
    <div class="mointor-block">
      <div class="title-box">
        <p>机库/无人机信息</p>
        <p @click="backBtn">返回无人机列表 >> </p>
      </div>
      <div class="task-box">
        <div class="block-date">
          <span style="color: #FFFFFF;font-size: 1.125rem;font-family: AlibabaPuHuiTi;">选择机场/无人机：</span>
          <el-select v-model="airNumberValue" placeholder="请选择无人机" style="width: 9vw" class="selectBox"
            @change="submitBtn">
            <el-option v-for="item in airOptions" :key="item.deviceSn" :label="item.nickName" :value="item.deviceSn" />
          </el-select>
        </div>
        <div class="air-status-box" v-if="airNumberValue">
          <div class="air-status" @click="switchBtn(0)" v-if="manualActive">
            <div class="left-box" :class="{ 'left-box-active': infoActive == true }">
              <p>
                <img v-if="!infoActive" src="@/assets/icons/jichang.png" alt="">
                <img v-else src="@/assets/icons/jichang-active.png" alt="">
              </p>
              <p>机场</p>
              <div class="status-word" :style="dockInfo[osdVisible.gateway_sn] ? dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code == EDockModeCode.Remote_Debugging ?
                'color: #FED91B' : dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code !== EDockModeCode.Disconnected ?
                  'color: #40F376' : 'color: #FA2256'
                : 'color: #FA2256;'">
                {{ dockInfo[osdVisible.gateway_sn] ?
                  theEDockModeCode[dockInfo[osdVisible.gateway_sn].basicOsd?.mode_code +
                  1] : theEDockModeCode[EDockModeCode.Disconnected + 1] }}
              </div>
            </div>
          </div>
          <div class="air-status" @click="switchBtn(1)">
            <div class="left-box" :class="{ 'left-box-active': infoActive == false }">
              <p>
                <img v-if="infoActive" src="@/assets/icons/wurenji.png" alt="">
                <img v-else src="@/assets/icons/wurenji-active.png" alt="">
              </p>
              <p>无人机</p>
              <div class="status-word"
                :style="deviceInfo1[osdVisible.sn] && deviceInfo1[osdVisible.sn]?.mode_code !== EModeCode.Disconnected ? 'color: #40F376' : 'color: #979797;'">
                {{ deviceInfo1[osdVisible.sn] ? theEModeCode[deviceInfo1[osdVisible.sn]?.mode_code] :
                  theEModeCode[EModeCode.Disconnected] }}
              </div>
            </div>
          </div>
        </div>
        <div class="warning-box">
          <span class="word-loop" v-if="hmsInfo">{{ Msgformatter(hmsInfo[osdVisible.gateway_sn]) }} {{
            Msgformatter(hmsInfo[osdVisible.sn]) }}</span>
        </div>
        <div class="air-info" v-if="infoActive">
          <div class="weather-info">
            <div style="font-size: 14px;color: #FFFFFF;font-family: AlibabaPuHuiTi;">机场信息</div>
            <div class="actual-weather">
              <div class="actual-list list1">
                <p>{{ (deviceInfo.dock?.basicOsd?.wind_speed ?? str) + 'm/s' }}</p>
                <p>风速计</p>
              </div>
              <div class="actual-list list2">
                <p v-if="deviceInfo.dock?.basicOsd?.rainfall && deviceInfo.dock?.basicOsd?.rainfall != 0">{{
                  RainfallEnum[deviceInfo.dock.basicOsd?.rainfall] }}</p>
                <p v-else>无降雨</p>
                <p>雨量计</p>
              </div>
              <div class="actual-list list3">
                <p>保险内</p>
                <p>保险</p>
              </div>
            </div>
            <div
              style="font-size: 14px;color: #FFFFFF;line-height: 1.9vh;margin-bottom:.4vh;font-family: AlibabaPuHuiTi;">
              预报天气数据</div>
            <div class="expect-weather">
              <div class="expect-box">
                <div class="expect-pic">
                  <img src="@/assets/icons/tianqi.png" alt="">
                </div>
                <div class="expect-list">
                  <p>少云</p>
                  <p>天气</p>
                </div>
              </div>
              <div class="expect-box">
                <div class="expect-pic">
                  <img src="@/assets/icons/fengsu.png" alt="">
                </div>
                <div class="expect-list">
                  <p>{{ (deviceInfo.dock?.basicOsd?.wind_speed ?? str) + 'm/s' }}</p>
                  <p>预测风速</p>
                </div>
              </div>
              <div class="expect-box">
                <div class="expect-pic">
                  <img src="@/assets/icons/jiangyu.png" alt="">
                </div>
                <div class="expect-list">
                  <p v-if="deviceInfo.dock?.basicOsd?.rainfall && deviceInfo.dock?.basicOsd?.rainfall != 0">{{
                    RainfallEnum[deviceInfo.dock?.basicOsd?.rainfall] }}</p>
                  <p v-else>无降雨</p>
                  <p>短时雨量</p>
                </div>
              </div>
              <div class="expect-box">
                <div class="expect-pic">
                  <img src="@/assets/icons/wendu.png" alt="">
                </div>
                <div class="expect-list">
                  <p>{{ deviceInfo.dock?.basicOsd?.temperature }}</p>
                  <p>温度</p>
                </div>
              </div>
              <div class="expect-box">
                <div class="expect-pic">
                  <img src="@/assets/icons/shidu.png" alt="">
                </div>
                <div class="expect-list">
                  <p>{{ deviceInfo.dock?.basicOsd?.humidity }}</p>
                  <p>相对湿度</p>
                </div>
              </div>
              <div class="expect-box">
                <div class="expect-pic">
                  <img src="@/assets/icons/dianliceng.png" alt="">
                </div>
                <div class="expect-list">
                  <p>平静</p>
                  <p>电离层</p>
                </div>
              </div>
            </div>
            <div
              style="font-size: 14px;color: #FFFFFF;line-height: 1.9vh;margin-bottom:.4vh;font-family: AlibabaPuHuiTi;">
              其他机场信息</div>
            <div class="other-info">
              <div class="other-list">
                <p>{{ deviceInfo.dock?.basicOsd?.network_state?.rate.toFixed(1) }}kb/s</p>
                <p>网络状态</p>
              </div>
              <div class="other-list">
                <p>{{ deviceInfo.dock?.workOsd?.job_number }}</p>
                <p>任务次数</p>
              </div>
              <div class="other-list">
                <p>{{ storageFormatter(deviceInfo.dock?.basicOsd?.storage?.used) }}</p>
                <p>空间使用</p>
              </div>
              <div class="other-list">
                <p>{{ storageFormatter(deviceInfo.dock?.basicOsd?.storage?.total) }}</p>
                <p>总空间</p>
              </div>
              <div class="other-list">
                <p>{{ deviceInfo.dock?.basicOsd?.drone_in_dock == true ? '在仓' : "飞行中" }}</p>
                <p>飞行器状态</p>
              </div>
              <!-- <div class="other-list">
                <p>保险内</p>
                <p>保险状态</p>
              </div> -->
            </div>
          </div>
        </div>
        <div class="uav-info" v-else>
          <div class="ipt-info">
            <div style="font-size: 14px;color: #FFFFFF;">无人机信息</div>
            <div class="uav-info-list-box">
              <div class="uav-info-list info1">
                <div class="info-word ">
                  <p>
                    电量
                    <img src="@/assets/icons/dianliang.png" alt=""
                      v-if="deviceInfo.device && deviceInfo.device.battery.capacity_percent !== str && deviceInfo.device?.battery.capacity_percent < 30">
                    <img src="@/assets/icons/dianliang1.png" alt=""
                      v-if="deviceInfo.device && deviceInfo.device.battery.capacity_percent !== str && deviceInfo.device?.battery.capacity_percent > 30 && deviceInfo.device?.battery.capacity_percent < 50">
                    <img src="@/assets/icons/dianliang2.png" alt="" v-else>
                  </p>
                  <p>{{ deviceInfo.device &&
                    deviceInfo.device.battery.capacity_percent
                    !== str ? deviceInfo.device?.battery.capacity_percent + '%' : str
                  }}</p>
                </div>
              </div>
              <div class="uav-info-list info2">
                <div class="info-word">
                  <p>名称</p>
                  <p :title="airInfo ? airInfo.nickName : str">{{ airInfo ? airInfo.nickName : str }}</p>
                </div>
              </div>
            </div>
            <div class="other-info">
              <div class="other-word">
                <p :title="!deviceInfo.device || deviceInfo.device.height === str ? str :
                  deviceInfo.device?.height.toFixed(2) + 'm'">{{ !deviceInfo.device || deviceInfo.device.height
                    === str ? str :
                    deviceInfo.device?.height.toFixed(2) + 'm' }}</p>
                <p>海拔高度</p>
              </div>
              <div class="other-word">
                <p>{{ !deviceInfo.device || deviceInfo.device.home_distance === str ? str :
                  deviceInfo.device?.home_distance.toFixed(2) + ' m' }}</p>
                <p>距离</p>
              </div>
              <div class="other-word">
                <p>{{ deviceInfo.device ? deviceInfo.device.position_state.gps_number : str }}</p>
                <p>卫星数量</p>
              </div>
              <div class="other-word">
                <p>{{ deviceInfo.device ? EGear[deviceInfo.device?.gear] : str }}</p>
                <p>飞行模式</p>
              </div>
            </div>
          </div>
        </div>
        <div class="chujing" v-if="!ifmActive && status == '1'" @click="treatBtn">
          一键出警
        </div>
        <div class="title-box">
          <p v-if="!ifmActive">航线选择</p>
          <p v-else>飞行信息</p>
        </div>
        <div class="task-list-bj" :style="!airNumberValue ? 'height: 40vh;' : ''" v-if="!ifmActive">
          <div class="list-box" v-for="(item, index) in wayLineList" @mouseenter="mouseenter($event, item)"
            @mouseleave="mouseleave" @click="wayLineClick(item)"
            :class="{ 'wayLineActive': item.wayline_id == waylineId }">
            <p :title="item.name">航线名称：{{ item.name }}</p>
            <p :title="item.dock_name">机场/无人机名称：{{ item.device_sn }}</p>
            <p class="executeBtn" v-if="item.status != 2" @click.stop="executeBtn(item)">执行</p>
          </div>
        </div>

        <div class="information-box" v-else>
          <div class="fly-flex-box">
            <div class="flyChart">
              <base-echarts :options="flyChartOptions" />
              <p style="text-align: center;color: #fff;">机头朝向{{ flyDataArr }}°</p>
            </div>
            <div class="flyChart">
              <base-echarts :options="ptzChartOptions" />
              <p style="text-align: center;color: #fff;">云台角度{{ ptzDataArr }}°</p>
            </div>
            <div class="speedChart">
              <base-echarts class="chartbg" :options="speedChartOptions1" />
              <p style="text-align: center;color: #fff;">
                水平速度
                <span v-if="deviceInfo.device.horizontal_speed && deviceInfo.device.horizontal_speed !=0">{{ Number(deviceInfo.device?.horizontal_speed).toFixed(2) || 0 }}m/s</span>
              </p>
            </div>
            <div class="speedChart">
              <base-echarts class="chartbg" :options="speedChartOptions2" />
              <p style="text-align: center;color: #fff;">
                垂直速度
                <span v-if="deviceInfo.device.vertical_speed && deviceInfo.device.vertical_speed !=0">{{ Number(deviceInfo.device?.vertical_speed).toFixed(2) || 0 }}m/s</span>
              </p>
            </div>
          </div>
          <div class="uav-info-box">
            <div class="uav-info info1">
              <div class="info-word">
                <p>
                  电量
                  <img src="@/assets/icons/dianliang.png" alt=""
                    v-if="deviceInfo.device && deviceInfo.device.battery.capacity_percent !== str && deviceInfo.device?.battery.capacity_percent < 30">
                  <img src="@/assets/icons/dianliang1.png" alt=""
                    v-if="deviceInfo.device && deviceInfo.device.battery.capacity_percent !== str && deviceInfo.device?.battery.capacity_percent > 30 && deviceInfo.device?.battery.capacity_percent < 50">
                  <img src="@/assets/icons/dianliang2.png" alt="" v-else>
                </p>
                <p>{{ deviceInfo.device &&
                  deviceInfo.device.battery.capacity_percent
                  !== str ? deviceInfo.device?.battery.capacity_percent + '%' : str
                }}</p>
              </div>
            </div>
            <div class="uav-info info2">

              <div class="info-word">
                <p>距离</p>
                <p :title="!deviceInfo.device || deviceInfo.device.home_distance === str ? str :
                  deviceInfo.device?.home_distance.toFixed(2) + 'm'">{{ !deviceInfo.device ||
                    deviceInfo.device.home_distance === str ? str :
                    deviceInfo.device?.home_distance.toFixed(2) + 'm' }}</p>
              </div>
            </div>
            <div class="uav-info info3">
              <div class="info-word">
                <p>名称</p>
                <p :title="airInfo ? airInfo.deviceName : str">{{ airInfo ? airInfo.deviceName : str }}</p>
              </div>
            </div>
            <div class="uav-info info4">
              <div class="info-word">
                <p>飞行模式</p>
                <p>{{ deviceInfo.device ? EGear[deviceInfo.device?.gear] : str }}</p>
              </div>
            </div>
            <div class="uav-info info5">
              <div class="info-word">
                <p>卫星数量</p>
                <p>{{ deviceInfo.device ? deviceInfo.device.position_state.gps_number : str }}</p>
              </div>
            </div>
            <div class="uav-info info6">
              <div class="info-word">
                <p>相对机场返航高度</p>
                <p v-if="dockInfo[osdVisible.gateway_sn]" :title="!deviceInfo.device || deviceInfo.device.height === str ? str :
                  deviceInfo.device?.height.toFixed(2) + 'm'">{{ !deviceInfo.device || deviceInfo.device.height
                    === str ? str :
                    deviceInfo.device?.height.toFixed(2) - dockInfo[osdVisible.gateway_sn].basicOsd?.height.toFixed(2) +
                    'm' }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="uav-pop" v-if="popActive" :style="`top: ${pageTop}px;`">
            <p class="title">无人机：</p>
            <p>编号：{{ airportObj ? JXsls(airportObj?.sub_device.device_model_key) : str }}</p>
            <p>电量：
              {{ uavObj.device &&
                uavObj.device.battery.capacity_percent
                !== str ? uavObj.device?.battery.capacity_percent + ' %' : str
              }}
            </p>
            <p>状态：
              {{ uavObj.device ? theEModeCode[uavObj.device?.mode_code] :
                theEModeCode[EModeCode.Disconnected] }}
            </p>
            <p>告警：无</p>
            <p>保险：保期内</p>
          </div> -->
      </div>

      <home-alert v-model:homeEventVisible="homeEventVisible" />

      <el-dialog class="job-box" modal-class="modal-event" v-model="jobVisible" title="任务：" top="25vh"
        @close="closeDialog" draggable :modal="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form label-width="auto" style="width:30vw" class="searchForm" :model="formQuery">
          <div class="searchBox">
            <el-form-item label="相对机场返航高度 (m):" class="locitionItem">
              <el-input-number v-model="formQuery.rthAltitude" placeholder="请输入" clearable />
            </el-form-item>
            <el-form-item label="变焦倍数:" class="locitionItem">
              <el-input-number v-model="formQuery.manualLen" placeholder="请输入" clearable />
            </el-form-item>
            <el-form-item label="航线飞行中失联:" class="locitionItem">
              <el-radio-group v-model="formQuery.outOfControlAction">
                <el-radio :value="0">返航</el-radio>
                <el-radio :value="1">悬停</el-radio>
                <el-radio :value="2">继续执行</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="智能识别:" class="locitionItem">
              <el-switch v-model="formQuery.autoDetect" inline-prompt active-text="开" inactive-text="关" />
            </el-form-item> -->
            <el-form-item label="自动断点续飞:" class="locitionItem">
              <el-switch v-model="formQuery.prepareJobResp.isFlight" inline-prompt active-text="开" inactive-text="关"
                :inactive-value="0" :active-value="1" />
            </el-form-item>
            <div class="buttonBox">
              <el-button type="primary" @click="closeDialog">取消</el-button>
              <el-button type="primary" @click="onFinish">执行</el-button>
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<style scoped lang="scss">
.left-monitor {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 29.2vw;
  height: 100vh;
  background: url("@/assets/icons/left-bg.png") no-repeat center;
  background-size: 100% 100%;
  z-index: 1;
  pointer-events: none;

  .mointor-block {
    width: 22vw;
    margin-top: 7.6vh;
    pointer-events: all;
  }

  .title-box {
    width: 19.5vw;
    height: 2.5vh;
    background: url("@/assets/icons/title-bg.png") center no-repeat;
    background-size: cover;
    display: flex;
    margin-left: .7vw;

    p:nth-child(1) {
      font-family: YouSheBiaoTiHei;
      font-size: 1.125rem;
      font-weight: normal;
      color: #fff;
      margin: 0 0 0 1.5vw;
      line-height: 2.1vh;
    }

    p:nth-child(2) {
      font-family: AlibabaPuHuiTi;
      font-size: .75rem;
      font-weight: normal;
      line-height: 2.1vh;
      color: #0BE8F6;
      margin-left: 3.9vw;
      cursor: pointer;
    }
  }

  .task-box {
    .block-date {
      margin-top: 1vh;
      margin-left: 2vw;

      :deep(.el-select) {
        margin-left: 1.2vw;
        height: 3vh;
        border: none;

        .el-select__wrapper {
          border: none;
          box-shadow: none;
          min-height: 3vh;
          border-radius: 5px;
          color: #fff;
          font-size: 1.125rem;
          color: #fff;
          background: rgba(124, 135, 161, 0.2);

          .el-select__caret {
            content: url('@/assets/icons/xiala.png');
            /* 你的自定义图标路径 */
            width: 15px;
            /* 根据图标大小调整 */
            height: 10px;
            /* 根据图标大小调整 */
          }
        }

        .el-select__placeholder {
          color: #fff;
          font-size: 1rem !important;
          font-family: AlibabaPuHuiTi;
        }
      }
    }

    .air-status-box {
      display: flex;
      align-items: center;
      margin-left: 1.8vw;
      margin-top: 1.3vh;
      margin-bottom: 0.8vh;
      cursor: pointer;

      .air-status {
        display: flex;
        align-items: center;

        .left-box {
          width: 8.7vw;
          height: 14.1vh;

          p:nth-child(1) {
            width: 5vw;
            height: 8.7vh;
            margin: 0 auto;

            img {
              width: 5vw;
              height: 8.7vh;
            }
          }

          p:nth-child(2) {
            font-family: YouSheBiaoTiHei;
            font-size: 1.125rem;
            font-weight: normal;
            letter-spacing: 0em;
            font-variation-settings: "opsz" auto;
            color: #FFFFFF;
            margin: .5vh 0;
          }

          p {
            text-align: center;
            color: #fff;
          }

          .status-word {
            font-size: .75rem;
            text-align: center;
            color: #fff;
            font-family: AlibabaPuHuiTi;
          }
        }

        .left-box-active {
          border-radius: 2px;
          background: linear-gradient(0deg, rgba(21, 154, 255, 0) 0%, rgba(21, 154, 255, 0.2) 100%);
          box-sizing: border-box;
          border: 1px solid;
          border-image: linear-gradient(180deg, #159AFF 12%, rgba(21, 154, 255, 0) 100%) 1;
        }
      }
    }

    .warning-box {
      // background-color: #009DFF;
      width: 16vw;
      height: 3vh;
      margin-left: 2.5vw;
      overflow: hidden;

      .word-loop {
        display: inline-block;
        white-space: nowrap;
        animation: 20s loop linear infinite normal;
        color: #FA2256;
      }

      @keyframes loop {
        0% {
          transform: translateX(20px);
          -webkit-transform: translateX(20px);
        }

        100% {
          transform: translateX(-100%);
          -webkit-transform: translateX(-100%);
        }
      }
    }

    .air-info {
      margin-top: 10px;
      margin-bottom: 1.6vh;

      .weather-info {
        margin-left: .9vw;

        .actual-weather {
          width: 18.8vw;
          height: 4.7vh;
          display: flex;
          justify-content: space-between;
          margin-bottom: .9vh;

          .actual-list {
            width: 5.9vw;
            height: 4.7vh;
            background-size: 100% 100%;
            margin-top: .9vh;

            p {
              margin-left: 3vw;
              margin-top: 2px;
            }

            p:nth-child(1) {
              font-size: 1.1494rem;
              font-family: YouSheBiaoTiHei;
              background: linear-gradient(180deg, #FFFFFF 25%, #9BCFFF 56%, #3389FF 73%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }

            p:nth-child(2) {
              font-family: AlibabaPuHuiTi;
              font-size: .75rem;
              font-weight: 500;
              line-height: .6125rem;
              letter-spacing: 0px;
              color: #FFFFFF;
            }
          }

          .list1 {
            background: url("@/assets/icons/yuliang-bg.png") no-repeat center;
            background-size: 100% 100%;
          }

          .list2 {
            background: url("@/assets/icons/fengsu-bg.png") no-repeat center;
            background-size: 100% 100%;
          }

          .list3 {
            background: url("@/assets/icons/baoxian.png") no-repeat center;
            background-size: 100% 100%;
          }
        }

        .expect-weather {
          width: 18.5vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .expect-box {
            width: 5.7vw;
            height: 3.6vh;
            display: flex;
            align-items: center;
            margin-bottom: 1vh;

            .expect-pic {
              width: 2vw;
              height: 3.6vh;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .expect-list {
              width: 3.2vw;
              margin-left: .5vw;

              p {
                margin: .3vh 0;
              }

              p:nth-child(1) {
                font-size: 1rem;
                font-weight: 500;
                line-height: 1.9vh;
                font-family: AlibabaPuHuiTi;
                color: #FFFFFF;
              }

              p:nth-child(2) {
                font-size: .75rem;
                font-weight: normal;
                line-height: 1.1vh;
                font-family: AlibabaPuHuiTi;
                color: #B0B0B0;
              }
            }
          }
        }

        .other-info {
          width: 19.5vw;
          height: 4.8vh;
          /* 自动布局 */
          display: flex;
          align-items: center;
          justify-content: space-around;
          background: linear-gradient(270deg, rgba(0, 133, 255, 0.03) 0%, rgba(0, 125, 255, 0.2) 100%);

          .other-list {
            p {
              margin: .4vh 0;
            }

            p:nth-child(1) {
              font-size: 1.125rem;
              font-weight: bold;
              line-height: 1.9vh;
              font-family: AlibabaPuHuiTi;
              color: #0BE8F6;
            }

            p:nth-child(2) {
              font-size: .75rem;
              font-weight: normal;
              line-height: 1.1vh;
              font-family: AlibabaPuHuiTi;
              color: #B0B0B0;
            }
          }
        }
      }
    }

    .uav-info {
      // margin-top: 10px;


      .ipt-info {
        margin-left: .9vw;
        margin-top: 1vh;

        .uav-info-list-box {
          width: 18.8vw;
          display: flex;
          justify-content: space-between;
          margin-top: .9vh;

          .uav-info-list {
            width: 8.7vw;
            height: 6.5vh;
            background-size: cover;

            // background-color: #00A8FF;
            .info-img {
              img {
                width: 100%;
                height: 100%;
              }
            }

            .info-word {
              margin-left: 4.7vw;
              margin-top: 1.3vh;

              p {
                width: 4.5vw;
                white-space: nowrap;
                /* 确保文本在一行内显示 */
                overflow: hidden;
                /* 隐藏溢出的内容 */
                text-overflow: ellipsis;
                /* 使用省略号表示文本溢出 */
                line-height: normal;
              }

              p:nth-child(1) {
                font-size: .875rem;
                font-weight: normal;
                line-height: .875rem;
                color: #FFFFFF;
                text-shadow: 0px 0px 4.69px rgba(30, 198, 255, 0.8);
                margin-top: .3vh;
                position: relative;

                img {
                  width: 1vw;
                  height: 1.9vh;
                  margin-left: .5vw;
                  position: absolute;
                  top: -0.2vh;
                }
              }

              p:nth-child(2) {
                font-family: YouSheBiaoTiHei;
                font-size: 1.125rem;
                font-weight: normal;
                line-height: 2.6vh;
                background: linear-gradient(180deg, #FFFFFF 25%, #9BE5FF 57%, #0DCAF5 73%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
              }
            }
          }

          .info1 {
            background: url("@/assets/icons/dianliang-bg.png") center no-repeat;
            background-size: cover;
          }

          .info2 {
            background: url("@/assets/icons/bianhao.png") center no-repeat;
            background-size: cover;
          }
        }

        .other-info {
          width: 19.5vw;
          height: 13.8vh;
          background: linear-gradient(270deg, rgba(0, 133, 255, 0.03) 0%, rgba(0, 125, 255, 0.2) 100%);
          margin-top: 1.2vh;
          margin-bottom: 1.5vh;
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap;

          .other-word {
            width: 9vw;
            height: 7vh;

            p {
              margin-left: 2.6vw;
            }

            p:nth-child(1) {
              font-size: 1.125rem;
              font-weight: bold;
              line-height: 1.9vh;
              color: #0BE8F6;
              margin-top: 1.4vh;
            }

            p:nth-child(2) {
              font-size: .75rem;
              font-weight: normal;
              line-height: 2.5vh;
              color: #B0B0B0;
            }
          }
        }
      }
    }

    .chujing {
      width: 11.6vw;
      height: 3vh;
      margin-bottom: 1.5vh;
      margin-left: 4.7vw;
      cursor: pointer;
      background: url("@/assets/images/chujing-bg.png") center no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 3vh;
      color: #fff;
      font-family: YouSheBiaoTiHei;
      font-size: 1.125rem;
      font-weight: normal;
    }

    .task-list-bj {
      width: 20.2vw;
      height: 30vh;
      margin: .625rem 0;
      overflow-y: auto;

      .list-box {
        width: 18.8vw;
        height: 11.1vh;
        margin-left: .9vw;
        margin-top: .9vh;

        position: relative;
        cursor: pointer;
        background: linear-gradient(270deg, rgba(73, 72, 79, 0.19) 0%, rgba(89, 83, 132, 0.19) 100%);
        box-sizing: border-box;
        border: 1px solid;
        border-image: linear-gradient(270deg, rgba(136, 141, 141, 0.38) 0%, rgba(136, 141, 141, 0.55) 97%) 1;

        p {
          font-size: .875rem;
          color: #fff;
          margin: 1.1vh .9vw;
          font-family: AlibabaPuHuiTi;
          white-space: nowrap;
          /* 确保文本在一行内显示 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
          /* 使用省略号表示文本溢出 */
          // line-height: normal;
        }

        p:nth-child(1) {
          font-size: 1.125rem;
          font-weight: 500;
          line-height: 20px;
          font-family: AlibabaPuHuiTi;
          color: #009DFF;
        }

        .statusWord {
          width: 10vw;
        }

        .executeBtn {
          position: absolute;
          right: -.3vw;
          bottom: -.7vh;
          width: 4vw;
          height: 3.3vh;
          background: url("@/assets/icons/zhixing.png") no-repeat center;
          background-size: cover;
          font-family: YouSheBiaoTiHei;
          font-size: .875rem;
          font-weight: normal;
          line-height: 3vh;
          text-align: center;
          cursor: pointer;

        }
      }

      .wayLineActive {
        border: 1px solid #fff;
      }
    }

    .information-box {
      .fly-flex-box {
        display: flex;
        width: 20.2vw;
        height: 13.2vh;
        justify-content: space-around;
        margin: 2rem 0 0 0rem;

        .flyChart {
          width: 3.9vw;
          height: 6.9vh;

          p {
            width: 3.9vw;
            margin-top: 1.4vh;
            font-size: .875rem;
            color: #fff;
            font-family: AlibabaPuHuiTi;
          }
        }

        .speedChart {
          width: 3.9vw;
          height: 6.9vh;

          .chartbg {
            background: url("@/assets/icons/yibiaopan.png") no-repeat center;
            background-size: 100% 100%;
          }

          p {
            width: 3.9vw;
            margin-top: 1.4vh;
            font-size: .875rem;
            color: #fff;
            text-align: center;
            font-family: AlibabaPuHuiTi;
          }
        }
      }

      .uav-info-box {
        width: 19.1vw;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .uav-info {
          width: 8.7vw;
          height: 6.5vh;
          background-size: cover;
          margin-bottom: 1vh;

          // background-color: #00A8FF;
          .info-img {
            img {
              width: 100%;
              height: 100%;
            }
          }

          .info-word {
            margin-left: 4.7vw;
            margin-top: 1.2vh;

            p {
              width: 4.5vw;
              white-space: nowrap;
              /* 确保文本在一行内显示 */
              overflow: hidden;
              /* 隐藏溢出的内容 */
              text-overflow: ellipsis;
              /* 使用省略号表示文本溢出 */
              line-height: normal;
            }

            p:nth-child(1) {
              font-size: .875rem;
              font-weight: normal;
              line-height: 1.5vh;
              font-family: AlibabaPuHuiTi;
              color: #FFFFFF;
              text-shadow: 0px 0px 4.69px rgba(30, 198, 255, 0.8);
              margin-top: .3vh;
              position: relative;

              img {
                width: 1vw;
                height: 1.9vh;
                margin-left: .5vw;
                position: absolute;
                top: -0.1vh;
              }
            }

            p:nth-child(2) {
              font-family: YouSheBiaoTiHei;
              font-size: 1.125rem;
              font-weight: normal;
              line-height: 2.6vh;
              background: linear-gradient(180deg, #FFFFFF 25%, #9BE5FF 57%, #0DCAF5 73%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }
          }
        }

        .info1 {
          background: url("@/assets/icons/dianliang-bg.png") center no-repeat;
          background-size: cover;
        }

        .info2 {
          background: url("@/assets/icons/juli.png") center no-repeat;
          background-size: cover;
        }

        .info3 {
          background: url("@/assets/icons/bianhao.png") center no-repeat;
          background-size: cover;
        }

        .info4 {
          background: url("@/assets/icons/moshi.png") center no-repeat;
          background-size: cover;
        }

        .info5 {
          background: url("@/assets/icons/weixing.png") center no-repeat;
          background-size: cover;
        }

        .info6 {
          background: url("@/assets/icons/gaodu.png") center no-repeat;
          background-size: cover;
        }
      }
    }

    .uav-pop {
      width: 10vw;
      height: 25vh;
      background-color: #0d132f;
      position: absolute;
      right: -9vw;
      z-index: 1;

      .title {
        color: #fff;
        margin-top: 1.5625rem;
      }

      p {
        margin-left: 1.25rem;
        color: #bebea3;
        margin-top: .9375rem;
      }
    }
  }

  .shousuo {
    position: absolute;
    right: -40px;
    top: 25%;
    width: 36px;
    height: 190px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
}


.shrink {
  position: absolute;
  top: 32%;
  left: 0;
  width: 36px;
  height: 190px;
  cursor: pointer;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss">
.job-box {
  width: 30vw;
  // height: 40vh;
  background: url("@/assets/images/small-pop.png") no-repeat center;
  background-size: 100% 100%;
  pointer-events: auto;
  padding: .25rem 1rem;

  .el-dialog__header {
    .el-dialog__title {
      color: #fff;
      display: inline-block;
      margin-top: .4375rem;
      font-family: AlibabaPuHuiTi;
    }
  }

  .dialog-word {
    font-size: 1rem;
    color: #f5c104;
    text-align: center;
    margin: 20px auto;
  }


  .searchForm {
    margin: 20px auto;

    .searchBox {
      width: 25vw;
      position: relative;

      .searchItem {
        margin-right: 0.625rem;

        .el-form-item__label {
          color: #fff;
        }

        .el-input {
          width: 17vw;

          .el-input__wrapper {
            background-color: rgba(0, 0, 0, 0.3);

            .el-input__inner {
              color: #fff;
            }
          }
        }

        .alarm-select {
          color: #fff;
          width: 17vw;
          background-color: #126672;
        }
      }

      .locitionItem {
        margin-right: 0.625rem;

        .el-form-item__label {
          font-family: AlibabaPuHuiTi;
          color: #fff;
        }

        .el-form-item__content {
          width: 17vw;
          justify-content: space-between;
        }

        .el-input-number {
          .el-input-number__decrease {
            background-color: rgba(0, 0, 0, 0.3);
          }

          .el-input-number__increase {
            background-color: rgba(0, 0, 0, 0.3);
          }
        }

        .el-radio-group {
          .el-radio__label {
            color: #fff;
          }
        }

        .el-input {
          width: 8vw;

          .el-input__wrapper {
            background-color: rgba(0, 0, 0, 0.3);

            .el-input__inner {
              color: #fff;
            }
          }
        }

        .el-switch {
          .el-switch__label {
            color: #E8EBEF;
          }

          .el-switch__core {
            background: linear-gradient(115deg, rgba(73, 73, 73, 0.83) 0%, #DCDCDC 100%);
            border: none;
          }
        }

        .el-switch.is-checked {
          .el-switch__core {
            background: linear-gradient(115deg, rgba(64, 255, 249, 0.83) 0%, #408CFF 100%);
            border: none;
          }
        }

      }

      .buttonBox {
        text-align: center;
      }
    }
  }

}
</style>
